import css from 'styled-jsx/css';

export default css`
  .checkbox-container {
    display: flex;
  }
  .checkbox-container-selected {
    font-weight: 700;
  }
  .checkbox-container-selected :global(label) {
    font-weight: 700;
    color: var(--grey-dark) !important;
  }
  .checkbox-container :global(label) {
    margin-left: 5px !important;
    color: var(--grey-dark);
  }
  .select-all-alert {
    background: var(--background-utils);
    border: 1px solid rgba(146, 160, 174, 0.2);
    border-radius: 5px 0px 0px 5px;
    display: flex;
    align-items: center;
    padding: 10px 8px;
    margin-bottom: 8px;
  }
  .select-all-alert.sticky {
    position: fixed;
    top: 110px;
    left: 0px;
    z-index: 2;
    width: 100%;
    box-shadow: var(--shadow-light-hover);
  }
  .select-all-alert :global(.icon) {
    color: var(--grey-light);
  }
  .info-text {
    color: var(--grey-light);
    font-weight: 600;
    font-size: 15px;
    margin: auto;
  }
  .info-cta {
    cursor: pointer;
    color: var(--select-all);
  }
  .buttons-container {
    padding-bottom: 8px;
    border-bottom: solid thin #ccc5;
  }
  :global(input) {
    margin-bottom: 0px;
  }
  .action-bar {
    margin: 8px 0px;
  }
  .sort li {
    list-style-type: none;
    text-align: right;
    padding: var(--margin-md);
    transition: 0.2s ease;
  }
  .sort li:hover {
    background: #eee;
    cursor: pointer;
  }
  .mb-medium {
    margin-bottom: var(--margin-md);
  }
  .mobile-action {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 5;
    background: var(--background);
    width: 100%;
    padding: 1rem;
    z-index: 2;
    box-shadow: 0px 0px 40px 3px rgba(0, 0, 0, 0.2);
  }
  .button-group :global(.button) {
    background: none;
    border-radius: 0px;
    border: none;
    padding: 0px 8px;
    color: #000;
  }

  :global(label) {
    margin-left: 0px !important;
    color: var(--foreground);
  }
  .select-all-mobile .info-text {
    font-size: 13px;
    text-decoration: underline;
  }
  .select-all-mobile :global(.icon) {
    font-size: 14px;
    color: var(--primary);
  }
  .button-group.active {
    border: solid thin var(--grey-lighter);
    border-radius: var(--radius);
    background: white;
    padding: 0px 14px 0px 4px;
    gap: 5px;
  }
  .actions-container.sticky {
    position: fixed;
    left: 0px;
    background: var(--grey);
    z-index: 8;
    top: 55px;
    padding: 8px;
    width: 100%;
    margin: 0px;
  }
  .actions-container.embedded-actions-container {
    top: 0;
  }
  .actions-container.sticky .sort-wrap {
    display: none;
  }
  .sort-wrap {
    gap: 20px;
  }
  .sort-wrap :global(.icon) {
    margin: 0px !important;
    font-size: 22px;
  }
  .actions-container.sticky .action-bar {
    margin: 0px;
  }
  .action-mobile :global(.button) {
    background: var(--background-utils);
    border: solid thin var(--grey-lighter);
    font-size: 12px;
    position: relative;
  }
  .action-mobile :global(.button.focus) {
    color: var(--foreground) !important;
  }
  .action-mobile :global(.button.focus)::after {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    border-radius: 50px;
    top: 2px;
    right: 2px;
    background: var(--accent);
  }
  .action-mobile :global(.icon) {
    font-size: 22px;
  }
  .action-mobile :global(.button.iconBefore .icon),
  .action-mobile :global(.button.iconAfter .icon) {
    margin: 0px;
  }
  .actions-container {
    margin: 4px 0px;
    min-height: 30px;
  }
  :global(.modal) {
    overflow: inherit !important;
  }
  @media only screen and (max-width: 468px) {
    .button-group :global(.button) {
      background: none;
      border-radius: 0px;
      border: none;
      gap: 10px;
      color: #000;
      font-size: 14px;
      align-items: center;
      display: flex;
    }
  }
  :global(.dropdown-button.active .sort li p) {
    font-size: 15px;
  }
  .sort li p {
    max-width: 150px !important;
    white-space: break-spaces;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
  }

  .mobile-cart {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 200000000000000;
  }
  .mobile-cart :global(.icon) {
    font-size: 24px;
  }
  :global(.mobile-cart button) {
    width: 50px;
    height: 50px;
    border-radius: 100px;
    background: var(--primary);
    color: white;
    box-shadow: var(--shadow-light-hover);
  }
  .counter {
    position: absolute;
    top: -8px;
    left: 16px;
    border-radius: 50px;
    background: var(--error);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 18px;
    height: 18px;
  }
  .counter span {
    font-size: 10px;
    color: white;
    font-weight: 600;
  }
  :global(.icon-action .dropdown-button.active) {
    min-width: 170px !important;
    left: -65px;
    top: 49px;
  }

  :global(.icon-action .button.iconAfter .icon) {
    margin: 0px;
  }
  :global(.button.disabled) {
    color: var(--disabled) !important;
    cursor: auto !important;
  }
  .search-active :global(form) {
    width: 100%;
  }
  .search-active :global(.icon) {
    position: absolute;
    right: 10px;
  }
`;
